<template>
  <div class="content-positining text" style="height: inherit;">
    <div style="padding-bottom: 5%;" class="headlin-text">Contact Us</div>
    <br>
    <div style="margin-bottom: 2%;">Thank you for contacting us. <br/> One of our team’s representatives will be in touch with you soon.</div>
    <br>
    <button class="adway-btn-class" @click="homeButtonClick">
      <span class="btn__text__bold">Home</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ContactView',
  components: {
  },
  methods: {
    homeButtonClick () {
      this.$router.push('/')
    }
  }
}
</script>
